<template>
  <div>
    <WriteSqlModal ref="WriteSqlModal" v-on:complete="writeSQLComplete"></WriteSqlModal>
    <Spin fix v-show="loading">
      <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
      <div>加载中</div>
    </Spin>
    <Alert v-if="error" show-icon type="error">获取数据失败<a style="float: right" v-on:click="resetForm">重新获取</a></Alert>
    <div style="margin-top: 5px" v-else>
      <Form inline ref="viewForm" :model="viewForm" :label-width="60">
        <FormItem label="视图名称">
          <Input v-model="viewForm.name" style="width: 180px"/>
        </FormItem>
        <FormItem label="算法">
          <Select v-model="viewForm.algorithm" style="width: 100px" clearable>
            <Option label="Undefined" value='UNDEFINED'></Option>
            <Option label="Merge" value='MERGE'></Option>
            <Option label="Temptable" value='TEMPTABLE'></Option>
          </Select>
        </FormItem>
        <FormItem label="定义者">
          <Input v-model="viewForm.definer" style="width: 180px"/>
        </FormItem>
        <FormItem label="安全性">
          <Select v-model="viewForm.security" style="width: 100px" clearable>
            <Option label="Definer" value='DEFINER'></Option>
            <Option label="Invoker" value='INVOKER'></Option>
          </Select>
        </FormItem>
        <FormItem label="检查选项">
          <Select v-model="viewForm.check_option" style="width: 100px" clearable>
            <Option label="NONE" value='NONE'></Option>
            <Option label="Cascaded" value='CASCADED'></Option>
            <Option label="Local" value='LOCAL'></Option>
          </Select>
        </FormItem>
      </Form>
      <div class="ace-editor" :id="id"></div>
      <div class="info-edit-form-button">
        <Button type="primary" @click="ok" :loading="executing">提交</Button>
        <Button type="default" @click="resetForm" style="margin-left: 10px">重置</Button>
      </div>
    </div>
    <Modal title="执行结果" v-model="execResultModal" width="1000" footer-hide>
      <SQLResults ref="SQLResults" :callbackdata="callbackdata" :log="false"></SQLResults>
    </Modal>
  </div>
</template>

<script>
import { getViewData, createView, alterView, executeSQL } from '@/api/mysql'
import SQLResults from './sqlResults'
import WriteSqlModal from './writeSqlModal'
import '@/view/database/ace-export'
import { iRandom } from '@/libs/tools'

export default {
  name: 'dbViewEdit',
  components: {
    SQLResults,
    WriteSqlModal
  },
  data () {
    return {
      themePath: 'ace/theme/sqlserver',
      modePath: 'ace/mode/sql',
      aceEditor: '',
      old_data: {},
      viewForm: {
        name: '',
        algorithm: 'UNDEFINED',
        definer: '',
        security: 'DEFINER',
        check_option: 'CASCADED'
      },
      id: 'edit-view-ace-editor' + iRandom(),
      execResultModal: false,
      executing: false,
      loading: false,
      error: false
    }
  },
  props: {
    callbackdata: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  created: function () {
    if (this.callbackdata.viewName) {
      this.init()
    }
  },
  mounted: function () {
    this.aceEditor = ace.edit(this.id, {
      maxLines: 30,
      minLines: 20,
      fontSize: 14,
      value: '',
      theme: this.themePath,
      mode: this.modePath,
      wrap: 1,
      tabSize: 4
    })
    // 激活自动提示
    this.aceEditor.setOptions({
      enableSnippets: true,
      enableLiveAutocompletion: true,
      enableBasicAutocompletion: true,
      printMargin: false,
      printMarginColumn: 120
    })
  },
  methods: {
    init () {
      let params = {
        id: this.callbackdata.instance_id,
        db: this.callbackdata.db,
        view: this.callbackdata.viewName
      }
      this.loading = true
      this.error = false
      getViewData(params).then(res => {
        const result = res.data.view[0]
        this.viewForm = result
        this.aceEditor.setValue(result.view_definition)
        this.old_data = JSON.parse(JSON.stringify(result))
        this.loading = false
      }).catch(res => {
        this.loading = false
      })
    },
    ok () {
      let reqData = {
        name: this.viewForm.name,
        algorithm: this.viewForm.algorithm,
        definer: this.viewForm.definer,
        security: this.viewForm.security,
        check_option: this.viewForm.check_option,
        view_definition: this.aceEditor.getValue()
      }
      if (!reqData.name) {
        this.$Notice.error({
          title: '视图名称是必填的'
        })
        return false
      } else if (!reqData.view_definition) {
        this.$Notice.error({
          title: '定义是必填的'
        })
        return false
      }
      if (this.callbackdata.viewName) {
        let isDiff = false
        for (let i in reqData) {
          if (reqData[i] !== this.old_data[i]) {
            isDiff = true
            break
          }
        }
        if (isDiff) {
          reqData._old_name = this.old_data.name
          alterView(reqData).then(res => {
            this.$refs.WriteSqlModal.open(res.data.sql, 'view')
          })
        } else {
          this.$Notice.warning({
            title: '没有任何修改！'
          })
        }
      } else {
        createView(reqData).then(res => {
          this.$refs.WriteSqlModal.open(res.data.sql, 'view')
        })
      }
    },
    resetForm () {
      this.viewForm = {
        name: '',
        algorithm: 'UNDEFINED',
        definer: '',
        security: 'DEFINER',
        check_option: 'CASCADED'
      }
      this.aceEditor.setValue('')
      if (this.callbackdata.viewName) {
        this.init()
      }
    },
    writeSQLComplete (sql) {
      this.CreateViewSqlComplete(sql)
    },
    // 开始执行SQL
    CreateViewSqlComplete (sql) {
      let data = {
        id: this.callbackdata.instance_id,
        db: this.callbackdata.db,
        sql: sql,
        limit: '100'
      }
      let that = this
      that.executing = true
      executeSQL(data).then(res => {
        let results = []
        res.data.results.forEach(function (item, index) {
          if (item['success']) {
            that.$Notice.success({
              title: '操作成功',
              desc: item['msg']
            })
            if (!that.callbackdata.viewName) {
              let pushData = {
                tab_id: that.callbackdata.id,
                db: that.callbackdata.db,
                viewName: that.viewForm.name
              }
              that.$emit('callBack', 'createViewSuccess', pushData)
            } else {
              that.callbackdata.viewName = that.viewForm.name
              that.init()
            }
          } else {
            that.$Notice.error({
              title: item['msg']
            })
          }
          results.push({'id': index + 1, 'res': item['data'], 'columns': [], 'msg': item['msg']})
          let cols = Object.keys(item['data'][0])
          if (cols) {
            cols.forEach(function (row) {
              results[index].columns.push({'title': row, 'key': row, 'minWidth': 130})
            })
          }
          that.execResultModal = true
        })
        that.executing = false
        that.$refs.SQLResults.showResult(results)
      }).catch(res => {
        that.executing = false
        if (res.request) {
          this.$Notice.error({
            title: '操作失败！请求状态码:' + res.request.status,
            desc: res.request.response
          })
        } else {
          this.$Notice.error({
            title: '操作失败！服务器无响应'
          })
        }
      })
    }
  }
}
</script>

<style scoped>
  .info-edit-form-button {
    background-color: #F5F7F9;
    text-align: center;
    height: 100px;
    display: block;
    line-height: 100px;
    margin-top: 10px;
  }
</style>
